export interface BaselineConditions {
  leaseHours: string;
  hvacSchedule: string;
  lightingSchedule: string;
  cleaningSchedule: string;
  staggeredStartupConfigured: boolean;
  demandLimitingConfigured: boolean;
  optimalStartStopConfigured: boolean;
}

export interface ProgramPhase {
  phase: number;
  name: string;
  status: string;
  startedAt?: string;
  completedAt?: string;
}

export interface Program {
  id: string;
  organizationId: string;
  buildingId: string;
  name: string;
  status: string;
  types: string[];
  baselinePeriodStart: string;
  baselinePeriodEnd: string;
  baselineConditions: BaselineConditions;
  occupancyStatus: string;
  notes: string;
  phases: ProgramPhase[];
  accountsInScope: string[];
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  isDeleted: boolean;
}

export interface Initiative {
  id: string;
  organizationId: string;
  buildingId: string;
  programId: string;
  name: string;
  description: string;
  strategy: string;
  chargeType: string;
  status: string;
  effectiveDate: string;
  suspendedAt?: string;
  affectedSpaces: string[];
  affectedAccounts: string[];
  notes: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
}

export const PROGRAM_STATUSES = [
  { value: 'active', label: 'Active' },
  { value: 'complete', label: 'Complete' },
  { value: 'archived', label: 'Archived' },
];

export const PROGRAM_TYPES = [
  { value: 'consumption', label: 'Consumption' },
  { value: 'demand', label: 'Demand' },
  { value: 'combined', label: 'Combined' },
];

export const PHASE_STATUSES = [
  { value: 'pending', label: 'Pending' },
  { value: 'active', label: 'Active' },
  { value: 'complete', label: 'Complete' },
];

export const INITIATIVE_STATUSES = [
  { value: 'proposed', label: 'Proposed' },
  { value: 'active', label: 'Active' },
  { value: 'suspended', label: 'Suspended' },
];

export const STRATEGIES = [
  { value: 'staggered_startup', label: 'Staggered Startup' },
  { value: 'demand_limiting', label: 'Demand Limiting' },
  { value: 'optimal_start_stop', label: 'Optimal Start/Stop' },
  { value: 'schedule_optimization', label: 'Schedule Optimization' },
  { value: 'after_hours_management', label: 'After-Hours Management' },
];

export const CHARGE_TYPES = [
  { value: 'energy', label: 'Energy' },
  { value: 'demand', label: 'Demand' },
];

export const emptyBaselineConditions = (): BaselineConditions => ({
  leaseHours: '',
  hvacSchedule: '',
  lightingSchedule: '',
  cleaningSchedule: '',
  staggeredStartupConfigured: false,
  demandLimitingConfigured: false,
  optimalStartStopConfigured: false,
});
